jQuery(document).ready(function($) {

    blockPage();

    let fvCardFund, fvLaterFund, fvExpeditedProcessing, cardFundingForm, laterFundingForm, expeditedProcessingForm;

    /**
     * Input Masking
     */
    $(".form-funding [name='zip']").inputmask({
        mask: "99999"
    });

    $(".form-funding [name='cardnumber']").inputmask({
        mask: '9999 9999 9999 9999'
    });

    $(".form-funding [name='securitycode']").inputmask({
        mask: '999'
    });

    // $(".form-funding [name='cardname']").inputmask({
    //     regex: "[a-zA-Z ]*"
    // });

    $(".form-funding [name='cardname']").on('keypress', function(e) {
        return /[a-z, ]/i.test(e.key);
    });

    $(".form-funding [name='cardname']").on('blur', function(e) {
        $(this).val($(this).val().trim());
    });

    var MIN_DEPOSIT = $("input[name=min_deposit]").val();
    var MAX_DEPOSIT = $("input[name=max_deposit]").val();
    var CREDIT_LIMIT = $("input[name=credit_limit]").val();

    /**
     * Pay by Card Form Validation
    */
    cardFundingForm = document.getElementById('cardFundingForm');
    let cardFundingFormFirstErrorField = null;
    if(cardFundingForm) {
        fvCardFund = FormValidation.formValidation(cardFundingForm,
        {
            fields: {
                deposit: {
                    validators: {
                        notEmpty: {
                            message: 'The deposit is required'
                        },
                        callback: {
                            message: 'The deposit amount is not allowed',
                            callback: function callback($field) {

                                var value = parseInt($field.value.replace("$", "").replace(/,/g, ''));

                                if(isNaN(value)) {
                                    return {
                                        valid: false,
                                        message: 'The deposit must be between $' + MIN_DEPOSIT + ' and $' + MAX_DEPOSIT
                                    };
                                }

                                if(value < MIN_DEPOSIT || value > MAX_DEPOSIT) {
                                    return {
                                        valid: false,
                                        message: 'The deposit must be between $' + MIN_DEPOSIT + ' and $' + MAX_DEPOSIT
                                    };
                                }

                                if(value > MIN_DEPOSIT && value < CREDIT_LIMIT) {
                                    cardFundingForm.querySelector('.deposit-warning').classList.remove('invisible');
                                    // cardDepositSliderInstance.alRangeSlider('update', {
                                    //     values: { to: value },
                                    // });

                                    return {
                                        valid: false,
                                        message: ''
                                        // message: 'The deposit cannot be between $101 and $169'
                                    };
                                }

                                cardFundingForm.querySelector('.deposit-warning').classList.add('invisible');

                                return {
                                    valid: true,
                                    message: ''
                                };
                            }
                        }
                    }
                },
                cardname: {
                    validators: {
                        notEmpty: {
                            message: 'The name on card is required'
                        },
                        regexp: {
                            regexp: /^[A-Za-z\s]*$/,
                            message: 'The name on card can consist of alphabetical characters only',
                        },
                    }
                },
                cardnumber: {
                    validators: {
                        callback: {
                            message: 'The card number is not valid',
                            callback: function callback($field) {

                                if($field.value.length === 0) {
                                    return {
                                        valid: false,
                                        message: 'The card number is required'
                                    };
                                }

                                var card = $.payment.cardType($field.value);     
                                if(card) {
                                    $($field.element).addClass(card);
                                } else {
                                    $($field.element).attr('class', 'form-control');
                                }

                                var valid = $.payment.validateCardNumber($field.value);

                                if(valid) {
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }
                                return {
                                    valid: false,
                                    message: 'The card number is not valid'
                                };
                            }
                        }
                    }
                },
                securitycode: {
                    validators: {
                        callback: {
                            message: 'The security code is not valid',
                            callback: function callback($field) {

                                if($field.value.length === 0) {
                                    return {
                                        valid: false,
                                        message: 'The security code is required'
                                    };
                                }

                                var cardNum = cardFundingForm.querySelector('[name="cardnumber"]').value;
                                var cardType = $.payment.cardType(cardNum);
                                var valid = $.payment.validateCardCVC($field.value, cardType);
                                if(valid) {
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }
                                return {
                                    valid: false,
                                    message: 'The security code is not valid'
                                };
                            }
                        }
                    }
                },
                expdate_month: {
                    selector: '.js-cc-exp-month',
                    validators: {
                        notEmpty: {
                            message: 'The field is required'
                        },
                    }
                },
                expdate_year: {
                    selector: '.js-cc-exp-year',
                    validators: {
                        notEmpty: {
                            message: 'The field is required'
                        },
                    }
                },
                address1: {
                    validators: {
                        notEmpty: {
                            message: 'The street address is required'
                        },
                        stringLength: {
                            max: 50,
                            message: 'The street address must be less than 50 characters long',
                        }
                    }
                },
                city: {
                    validators: {
                        notEmpty: {
                            message: 'The address city is required'
                        },
                        stringLength: {
                            max: 50,
                            message: 'The address city must be less than 50 characters long',
                        },
                        // regexp: {
                        //     regexp: /^[a-z\s]+$/i,
                        //     message: 'The address city can consist of alphabetical characters only',
                        // },
                    }
                },
                state: {
                    selector: '.js-cc-state',
                    validators: {
                        // notEmpty: {
                        //     message: 'The address state is required'
                        // },
                        callback: {
                            message: 'The valid state is required',
                            callback: function callback($field) {

                                var stateCode = $.trim($field.value);

                                if(stateCode.length == 2) {
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }
                                return {
                                    valid: false
                                };
                            }
                        }
                    }
                },
                zip: {
                    validators: {
                        callback: {
                            message: 'The valid zip number is required',
                            callback: function callback($field) {
                                var zip = $.trim($field.value);
                                var stripedValue = zip.replace(/\D/g, '');
                                if (stripedValue.length == 0) {
                                    return {
                                        valid: false,
                                        message: 'The address zip is required'
                                    };
                                }
                                if (stripedValue.length == 5) {
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }

                                return {
                                    valid: false
                                };
                            }
                        }
                    }
                },
            },
            plugins: {
                bootstrap5: new FormValidation.plugins.Bootstrap5(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                trigger: new FormValidation.plugins.Trigger({
                    event: {
                        cardname: 'blur',
                        cardnumber: 'blur',
                        securitycode: 'blur',
                        address1: 'blur',
                        city: 'blur',
                        state: 'blur',
                        zip: 'blur',
                        deposit: 'change'
                    }
                }),
            }
        }).on('core.form.valid', function() {

            updateDeposit(cardFundingForm);
            
            showAuthorization(cardFundingForm);

        }).on('plugins.message.displayed', function(e) {
            if (cardFundingFormFirstErrorField == null) {
                cardFundingFormFirstErrorField = e.element;
            }
        }).on('core.form.invalid', function(e) {
            var elementWrapper = $(cardFundingFormFirstErrorField).closest('.row');
            var elementPosition = elementWrapper.offset().top;

            $([document.documentElement, document.body]).animate({
                scrollTop: elementPosition
            }, 50, "linear");

            cardFundingFormFirstErrorField = null;
        });
    }

    /**
     * Pay Later Form Validation
    */
    laterFundingForm = document.getElementById('laterFundingForm');
    let laterFundingFormFirstErrorField = null;
    if(laterFundingForm) {
        fvLaterFund = FormValidation.formValidation(laterFundingForm,
        {
            fields: {
                deposit: {
                    validators: {
                        notEmpty: {
                            message: 'The deposit is required'
                        },
                        callback: {
                            message: 'The deposit amount is not allowed',
                            callback: function callback($field) {

                                var value = parseInt($field.value.replace("$", "").replace(/,/g, ''));

                                if(isNaN(value)) {
                                    return {
                                        valid: false,
                                        message: 'The deposit must be between $' + MIN_DEPOSIT + ' and $' + MAX_DEPOSIT
                                    };
                                }

                                if(value < MIN_DEPOSIT || value > MAX_DEPOSIT) {
                                    return {
                                        valid: false,
                                        message: 'The deposit must be between $' + MIN_DEPOSIT + ' and $' + MAX_DEPOSIT
                                    };
                                }

                                if(value > MIN_DEPOSIT && value < CREDIT_LIMIT) {
                                    laterFundingForm.querySelector('.deposit-warning').classList.remove('invisible');
                                    // cardDepositSliderInstance.alRangeSlider('update', {
                                    //     values: { to: value },
                                    // });

                                    return {
                                        valid: false,
                                        message: ''
                                        // message: 'The deposit cannot be between $101 and $169'
                                    };
                                }

                                laterFundingForm.querySelector('.deposit-warning').classList.add('invisible');

                                return {
                                    valid: true,
                                    message: ''
                                };
                            }
                        }
                    }
                },
                cardname: {
                    validators: {
                        notEmpty: {
                            message: 'The name on card is required'
                        },
                        regexp: {
                            regexp: /^[A-Za-z\s]*$/,
                            message: 'The name on card can consist of alphabetical characters only',
                        },
                    }
                },
                cardnumber: {
                    validators: {
                        callback: {
                            message: 'The card number is not valid',
                            callback: function callback($field) {

                                if($field.value.length === 0) {
                                    return {
                                        valid: false,
                                        message: 'The card number is required'
                                    };
                                }

                                var card = $.payment.cardType($field.value);     
                                if(card) {
                                    $($field.element).addClass(card);
                                } else {
                                    $($field.element).attr('class', 'form-control');
                                }

                                var valid = $.payment.validateCardNumber($field.value);

                                if(valid) {
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }
                                return {
                                    valid: false,
                                    message: 'The card number is not valid'
                                };
                            }
                        }
                    }
                },
                securitycode: {
                    validators: {
                        callback: {
                            message: 'The security code is not valid',
                            callback: function callback($field) {

                                if($field.value.length === 0) {
                                    return {
                                        valid: false,
                                        message: 'The security code is required'
                                    };
                                }

                                var cardNum = laterFundingForm.querySelector('[name="cardnumber"]').value;
                                var cardType = $.payment.cardType(cardNum);
                                var valid = $.payment.validateCardCVC($field.value, cardType);
                                if(valid) {
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }
                                return {
                                    valid: false,
                                    message: 'The security code is not valid'
                                };
                            }
                        }
                    }
                },
                expdate_month: {
                    selector: '.js-cc-exp-month',
                    validators: {
                        notEmpty: {
                            message: 'The field is required'
                        },
                    }
                },
                expdate_year: {
                    selector: '.js-cc-exp-year',
                    validators: {
                        notEmpty: {
                            message: 'The field is required'
                        },
                    }
                },
                address1: {
                    validators: {
                        notEmpty: {
                            message: 'The street address is required'
                        },
                        stringLength: {
                            max: 50,
                            message: 'The street address must be less than 50 characters long',
                        }
                    }
                },
                city: {
                    validators: {
                        notEmpty: {
                            message: 'The address city is required'
                        },
                        stringLength: {
                            max: 50,
                            message: 'The address city must be less than 50 characters long',
                        },
                        // regexp: {
                        //     regexp: /^[a-z\s]+$/i,
                        //     message: 'The address city can consist of alphabetical characters only',
                        // },
                    }
                },
                state: {
                    selector: '.js-cc-state',
                    validators: {
                        // notEmpty: {
                        //     message: 'The address state is required'
                        // },
                        callback: {
                            message: 'The valid state is required',
                            callback: function callback($field) {

                                var stateCode = $.trim($field.value);

                                if(stateCode.length == 2) {
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }
                                return {
                                    valid: false
                                };
                            }
                        }
                    }
                },
                zip: {
                    validators: {
                        callback: {
                            message: 'The valid zip number is required',
                            callback: function callback($field) {
                                var zip = $.trim($field.value);
                                var stripedValue = zip.replace(/\D/g, '');
                                if (stripedValue.length == 0) {
                                    return {
                                        valid: false,
                                        message: 'The address zip is required'
                                    };
                                }
                                if (stripedValue.length == 5) {
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }

                                return {
                                    valid: false
                                };
                            }
                        }
                    }
                },
            },
            plugins: {
                bootstrap5: new FormValidation.plugins.Bootstrap5(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                trigger: new FormValidation.plugins.Trigger({
                    event: {
                        cardname: 'blur',
                        cardnumber: 'blur',
                        securitycode: 'blur',
                        cc_address_line_: 'blur',
                        city: 'blur',
                        state: 'blur',
                        zip: 'blur',
                        deposit: 'change'
                    }
                }),
            }
        }).on('core.form.valid', function() {
             
            updateDeposit(laterFundingForm);
            
            showAuthorization(laterFundingForm);
             
        }).on('plugins.message.displayed', function(e) {
            if (laterFundingFormFirstErrorField == null) {
                laterFundingFormFirstErrorField = e.element;
            }
        }).on('core.form.invalid', function(e) {
            var elementWrapper = $(laterFundingFormFirstErrorField).closest('.row');
            var elementPosition = elementWrapper.offset().top;
 
            $([document.documentElement, document.body]).animate({
                scrollTop: elementPosition
            }, 50, "linear");
 
            laterFundingFormFirstErrorField = null;
        });
    }

    /**
     * Standalone Expedited Processing Form Validation
    */
    expeditedProcessingForm = document.getElementById('expeditedProcessingForm');
    let expeditedProcessingFormFirstErrorField = null;
    if(expeditedProcessingForm) {
        fvExpeditedProcessing = FormValidation.formValidation(expeditedProcessingForm,
        {
            fields: {
                cardname: {
                    validators: {
                        notEmpty: {
                            message: 'The name on card is required'
                        },
                        regexp: {
                            regexp: /^[A-Za-z\s]*$/,
                            message: 'The name on card can consist of alphabetical characters only',
                        },
                    }
                },
                cardnumber: {
                    validators: {
                        callback: {
                            message: 'The card number is not valid',
                            callback: function callback($field) {

                                if($field.value.length === 0) {
                                    return {
                                        valid: false,
                                        message: 'The card number is required'
                                    };
                                }

                                var card = $.payment.cardType($field.value);     
                                if(card) {
                                    $($field.element).addClass(card);
                                } else {
                                    $($field.element).attr('class', 'form-control');
                                }

                                var valid = $.payment.validateCardNumber($field.value);

                                if(valid) {
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }
                                return {
                                    valid: false,
                                    message: 'The card number is not valid'
                                };
                            }
                        }
                    }
                },
                securitycode: {
                    validators: {
                        callback: {
                            message: 'The security code is not valid',
                            callback: function callback($field) {

                                if($field.value.length === 0) {
                                    return {
                                        valid: false,
                                        message: 'The security code is required'
                                    };
                                }

                                var cardNum = expeditedProcessingForm.querySelector('[name="cardnumber"]').value;
                                var cardType = $.payment.cardType(cardNum);
                                var valid = $.payment.validateCardCVC($field.value, cardType);
                                if(valid) {
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }
                                return {
                                    valid: false,
                                    message: 'The security code is not valid'
                                };
                            }
                        }
                    }
                },
                expdate_month: {
                    selector: '.js-cc-exp-month',
                    validators: {
                        notEmpty: {
                            message: 'The field is required'
                        },
                    }
                },
                expdate_year: {
                    selector: '.js-cc-exp-year',
                    validators: {
                        notEmpty: {
                            message: 'The field is required'
                        },
                    }
                },
                address1: {
                    validators: {
                        notEmpty: {
                            message: 'The street address is required'
                        },
                        stringLength: {
                            max: 50,
                            message: 'The street address must be less than 50 characters long',
                        }
                    }
                },
                city: {
                    validators: {
                        notEmpty: {
                            message: 'The address city is required'
                        },
                        stringLength: {
                            max: 50,
                            message: 'The address city must be less than 50 characters long',
                        },
                        // regexp: {
                        //     regexp: /^[a-z\s]+$/i,
                        //     message: 'The address city can consist of alphabetical characters only',
                        // },
                    }
                },
                state: {
                    selector: '.js-cc-state',
                    validators: {
                        // notEmpty: {
                        //     message: 'The address state is required'
                        // },
                        callback: {
                            message: 'The valid state is required',
                            callback: function callback($field) {

                                var stateCode = $.trim($field.value);

                                if(stateCode.length == 2) {
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }
                                return {
                                    valid: false
                                };
                            }
                        }
                    }
                },
                zip: {
                    validators: {
                        callback: {
                            message: 'The valid zip number is required',
                            callback: function callback($field) {
                                var zip = $.trim($field.value);
                                var stripedValue = zip.replace(/\D/g, '');
                                if (stripedValue.length == 0) {
                                    return {
                                        valid: false,
                                        message: 'The address zip is required'
                                    };
                                }
                                if (stripedValue.length == 5) {
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }

                                return {
                                    valid: false
                                };
                            }
                        }
                    }
                },
            },
            plugins: {
                bootstrap5: new FormValidation.plugins.Bootstrap5(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                trigger: new FormValidation.plugins.Trigger({
                    event: {
                        cardname: 'blur',
                        cardnumber: 'blur',
                        securitycode: 'blur',
                        cc_address_line_: 'blur',
                        city: 'blur',
                        state: 'blur',
                        zip: 'blur',
                    }
                }),
            }
        }).on('core.form.valid', function() {
            
            showAuthorization(expeditedProcessingForm);
            
        }).on('plugins.message.displayed', function(e) {
            if (expeditedProcessingFormFirstErrorField == null) {
                expeditedProcessingFormFirstErrorField = e.element;
            }
        }).on('core.form.invalid', function(e) {
            var elementWrapper = $(expeditedProcessingFormFirstErrorField).closest('.row');
            var elementPosition = elementWrapper.offset().top;

            $([document.documentElement, document.body]).animate({
                scrollTop: elementPosition
            }, 50, "linear");

            expeditedProcessingFormFirstErrorField = null;
        });
    }

    /**
     * Standalone Deposit Funding Form Validation
    */
    depositFundingForm = document.getElementById('depositFundingForm');
    let depositFundingFormFirstErrorField = null;
    if(depositFundingForm) {
    fvDepositFunding = FormValidation.formValidation(depositFundingForm,
        {
            fields: {
                deposit: {
                    validators: {
                        callback: {
                            message: 'The deposit amount is not allowed',
                            callback: function callback($field) {
                                var value = parseInt($field.value.replace("$", "").replace(/,/g, ''));

                                var amountMin = 10;
                                var amountMax = depositFundingForm.querySelector('[name=amount_to_fund]').value;
                                var amountMinTxt = '$' + numberWithCommas(Number(amountMin).toFixed(0));
                                var amountMaxTxt = '$' + numberWithCommas(Number(amountMax).toFixed(0));

                                if(isNaN(value)) {
                                    return {
                                        valid: false,
                                        message: 'The deposit must be between ' + amountMinTxt + ' and ' + amountMaxTxt
                                    };
                                }

                                if(value < amountMin || value > amountMax) {
                                    return {
                                        valid: false,
                                        message: 'The deposit must be between ' + amountMinTxt + ' and ' + amountMaxTxt
                                    };
                                }

                                return {
                                    valid: true,
                                    message: ''
                                };
                            }
                        }
                    }
                },
                cardname: {
                    validators: {
                        notEmpty: {
                            message: 'The name on card is required'
                        },
                        regexp: {
                            regexp: /^[A-Za-z\s]*$/,
                            message: 'The name on card can consist of alphabetical characters only',
                        },
                    }
                },
                cardnumber: {
                    validators: {
                        callback: {
                            message: 'The card number is not valid',
                            callback: function callback($field) {

                                if($field.value.length === 0) {
                                    return {
                                        valid: false,
                                        message: 'The card number is required'
                                    };
                                }

                                var card = $.payment.cardType($field.value); 

                                if(card) {
                                    $($field.element).addClass(card);
                                } else {
                                    $($field.element).attr('class', 'form-control');
                                }

                                var valid = $.payment.validateCardNumber($field.value);

                                if(valid) {
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }
                                return {
                                    valid: false,
                                    message: 'The card number is not valid'
                                };
                            }
                        }
                    }
                },
                securitycode: {
                    validators: {
                        callback: {
                            message: 'The security code is not valid',
                            callback: function callback($field) {

                                if($field.value.length === 0) {
                                    return {
                                        valid: false,
                                        message: 'The security code is required'
                                    };
                                }

                                var cardNum = depositFundingForm.querySelector('[name="cardnumber"]').value;
                                var cardType = $.payment.cardType(cardNum);
                                var valid = $.payment.validateCardCVC($field.value, cardType);
                                if(valid) {
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }
                                return {
                                    valid: false,
                                    message: 'The security code is not valid'
                                };
                            }
                        }
                    }
                },
                expdate_month: {
                    selector: '.js-cc-exp-month',
                    validators: {
                        notEmpty: {
                            message: 'The field is required'
                        },
                    }
                },
                expdate_year: {
                    selector: '.js-cc-exp-year',
                    validators: {
                        notEmpty: {
                            message: 'The field is required'
                        },
                    }
                },
                address1: {
                    validators: {
                        notEmpty: {
                            message: 'The street address is required'
                        },
                        stringLength: {
                            max: 50,
                            message: 'The street address must be less than 50 characters long',
                        }
                    }
                },
                city: {
                    validators: {
                        notEmpty: {
                            message: 'The address city is required'
                        },
                        stringLength: {
                            max: 50,
                            message: 'The address city must be less than 50 characters long',
                        },
                        // regexp: {
                        //     regexp: /^[a-z\s]+$/i,
                        //     message: 'The address city can consist of alphabetical characters only',
                        // },
                    }
                },
                state: {
                    selector: '.js-cc-state',
                    validators: {
                        // notEmpty: {
                        //     message: 'The address state is required'
                        // },
                        callback: {
                            message: 'The valid state is required',
                            callback: function callback($field) {

                                var stateCode = $.trim($field.value);

                                if(stateCode.length == 2) {
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }
                                return {
                                    valid: false
                                };
                            }
                        }
                    }
                },
                zip: {
                    validators: {
                        callback: {
                            message: 'The valid zip number is required',
                            callback: function callback($field) {
                                var zip = $.trim($field.value);
                                var stripedValue = zip.replace(/\D/g, '');
                                if (stripedValue.length == 0) {
                                    return {
                                        valid: false,
                                        message: 'The address zip is required'
                                    };
                                }
                                if (stripedValue.length == 5) {
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }

                                return {
                                    valid: false
                                };
                            }
                        }
                    }
                },
            },
            plugins: {
                bootstrap5: new FormValidation.plugins.Bootstrap5(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                trigger: new FormValidation.plugins.Trigger({
                    event: {
                        deposit: 'blur',
                        cardname: 'blur',
                        cardnumber: 'blur',
                        securitycode: 'blur',
                        cc_address_line_: 'blur',
                        city: 'blur',
                        state: 'blur',
                        zip: 'blur',
                    }
                }),
            }
        }).on('core.form.valid', function() {
   
            showAuthorization(depositFundingForm);
            
        }).on('plugins.message.displayed', function(e) {
            if (depositFundingFormFirstErrorField == null) {
                depositFundingFormFirstErrorField = e.element;
            }
        }).on('core.form.invalid', function(e) {
            var elementWrapper = $(depositFundingFormFirstErrorField).closest('.row');
            var elementPosition = elementWrapper.offset().top;

            $([document.documentElement, document.body]).animate({
                scrollTop: elementPosition
            }, 50, "linear");

            depositFundingFormFirstErrorField = null;
        });
    }

    /**
     * Set Initial deposit values
     */
    if(cardFundingForm) {
        setDepositValue('$' + MIN_DEPOSIT, cardFundingForm);
    }
    if(laterFundingForm) {
        setDepositValue('$' + MIN_DEPOSIT, laterFundingForm);
    }

    /**
     * Deposit 'on keypress' event handler
     */
    $("[name='deposit']").on('keypress', function(e) {
        return isNumber(e);
    });

    function isNumber(event) {
        event = (event) ? event : window.event;
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    /**
     * Deposit 'on change' event handler
     */
    $("#cardFundingForm [name='deposit']").on('change', function(e) {
        var value = e.target.value;
        setDepositValue(value, cardFundingForm);
    });

    $("#laterFundingForm [name='deposit']").on('change', function(e) {
        var value = e.target.value;
        setDepositValue(value, laterFundingForm);
    });

    $("#depositFundingForm [name='deposit']").on('change', function(e) {
        var value = e.target.value;
        setDepositValue(value, depositFundingForm);
    });

    function setDepositValue(value, form) {
        var deposit = value.replace("$", "").replace(/,/g, '');
        deposit = isNaN(deposit) ? "" : deposit; // prevent string input
        var formated = '$' + numberWithCommas(Number(deposit).toFixed(0));
        
        form.querySelector('[name=deposit]').value = formated;

        if(form.id == 'cardFundingForm') {
            var cfDepositRevalidated = _.debounce(function () {
                fvCardFund.revalidateField('deposit');
            }, 500);

            cfDepositRevalidated();
        }

        if(form.id == 'laterFundingForm') {
            var lfDepositRevalidated = _.debounce(function () {
                fvLaterFund.revalidateField('deposit');
            }, 500);
            
            lfDepositRevalidated();
        }

        if(form.id == 'depositFundingForm') {
            var fundingDepositRevalidated = _.debounce(function () {
                fvDepositFunding.revalidateField('deposit');
            }, 500);
            
            fundingDepositRevalidated();
        }

        if(form.id == 'cardFundingForm' || form.id == 'laterFundingForm') {
            if(value > MIN_DEPOSIT && value < CREDIT_LIMIT) {
                form.querySelector('.deposit-warning').classList.remove('invisible');
            } else {
                form.querySelector('.deposit-warning').classList.add('invisible');
            }
        }
    }

    function updateDeposit(form)
    {
        var deposit = form.querySelector('[name=deposit]').value.replace("$", "").replace(/,/g, '');

        $.ajax({
            url: '/apply/deposit',
            type: 'POST',
            data: { deposit : deposit, form : form.id },
        }).done(function(response) {
            // console.log(response);
        }).fail(function(data) {
            
        });
    }

    /**
     * Selectize
     */
    var $form;
    if($('#cardFundingForm').length > 0) {
        $form = $('#cardFundingForm');

        var $cfExpMonth = $form.find("select[name='expdate_month']").selectize({
            onInitialize: function() {
                this.$control_input.attr('inputmode', 'none');
            }
        });
        var cfExpMonth = $cfExpMonth[0].selectize;

        var $cfExpYear = $form.find("select[name='expdate_year']").selectize({
            onInitialize: function() {
                this.$control_input.attr('inputmode', 'none');
            }
        });
        var cfExpYear = $cfExpYear[0].selectize;

        var $cfState = $form.find("select[name='state']").selectize({
            onInitialize: function() {
                this.$control_input.attr('inputmode', 'none');
            }
        });
        var cfState = $cfState[0].selectize;

        // Reformat cc expiry date for sending to api
        $cfExpMonth.on('change', function(e) {
            var cfExpValue = cfExpMonth.getValue() + '/' + cfExpYear.getValue();
            $form.find("select[name='expdate']").val(cfExpValue);
            fvCardFund.revalidateField('expdate_month');
        });
        $cfExpYear.on('change', function(e) {
            var cfExpValue = cfExpMonth.getValue() + '/' + cfExpYear.getValue();
            $form.find("select[name='expdate']").val(cfExpValue);
            fvCardFund.revalidateField('expdate_year');
        });
    }

    if($('#laterFundingForm').length > 0) {
        $form = $('#laterFundingForm');

        var $lfExpMonth = $form.find("select[name='expdate_month']").selectize({
            onInitialize: function() {
                this.$control_input.attr('inputmode', 'none');
            }
        });
        var lfExpMonth = $lfExpMonth[0].selectize;

        var $lfExpYear = $form.find("select[name='expdate_year']").selectize({
            onInitialize: function() {
                this.$control_input.attr('inputmode', 'none');
            }
        });
        var lfExpYear = $lfExpYear[0].selectize;

        var $lfState = $form.find("select[name='state']").selectize({
            onInitialize: function() {
                this.$control_input.attr('inputmode', 'none');
            }
        });
        var lfState = $lfState[0].selectize;

        // Reformat cc expiry date for sending to api
        $lfExpMonth.on('change', function(e) {
            var lfExpValue = lfExpMonth.getValue() + '/' + lfExpYear.getValue();
            $form.find("select[name='expdate']").val(lfExpValue);
            fvLaterFund.revalidateField('expdate_month');
        });
        $lfExpYear.on('change', function(e) {
            var lfExpValue = lfExpMonth.getValue() + '/' + lfExpYear.getValue();
            $form.find("select[name='expdate']").val(lfExpValue);
            fvLaterFund.revalidateField('expdate_year');
        });
    }

    if($('#expeditedProcessingForm').length > 0) {
        $form = $('#expeditedProcessingForm');

        var $epExpMonth = $form.find("select[name='expdate_month']").selectize({
            onInitialize: function() {
                this.$control_input.attr('inputmode', 'none');
            }
        });
        var epExpMonth = $epExpMonth[0].selectize;

        var $epExpYear = $form.find("select[name='expdate_year']").selectize({
            onInitialize: function() {
                this.$control_input.attr('inputmode', 'none');
            }
        });
        var epExpYear = $epExpYear[0].selectize;

        var $epState = $form.find("select[name='state']").selectize({
            onInitialize: function() {
                this.$control_input.attr('inputmode', 'none');
            }
        });
        var epState = $epState[0].selectize;

        // Reformat cc expiry date for sending to api
        $epExpMonth.on('change', function(e) {
            var epExpValue = epExpMonth.getValue() + '/' + epExpYear.getValue();
            $form.find("select[name='expdate']").val(epExpValue);
            fvExpeditedProcessing.revalidateField('expdate_month');
        });
        $epExpYear.on('change', function(e) {
            var epExpValue = epExpMonth.getValue() + '/' + epExpYear.getValue();
            $form.find("select[name='expdate']").val(epExpValue);
            fvExpeditedProcessing.revalidateField('expdate_year');
        });
    }

    if($('#depositFundingForm').length > 0) {
        $form = $('#depositFundingForm');

        var $dfExpMonth = $form.find("select[name='expdate_month']").selectize({
            onInitialize: function() {
                this.$control_input.attr('inputmode', 'none');
            }
        });
        var dfExpMonth = $dfExpMonth[0].selectize;

        var $dfExpYear = $form.find("select[name='expdate_year']").selectize({
            onInitialize: function() {
                this.$control_input.attr('inputmode', 'none');
            }
        });
        var dfExpYear = $dfExpYear[0].selectize;

        var $dfState = $form.find("select[name='state']").selectize({
            onInitialize: function() {
                this.$control_input.attr('inputmode', 'none');
            }
        });
        var dfState = $dfState[0].selectize;

        // Reformat cc expiry date for sending to api
        $dfExpMonth.on('change', function(e) {
            var dfExpValue = dfExpMonth.getValue() + '/' + dfExpYear.getValue();
            $form.find("select[name='expdate']").val(dfExpValue);
            fvDepositFunding.revalidateField('expdate_month');
        });
        $dfExpYear.on('change', function(e) {
            var dfExpValue = dfExpMonth.getValue() + '/' + dfExpYear.getValue();
            $form.find("select[name='expdate']").val(dfExpValue);
            fvDepositFunding.revalidateField('expdate_year');
        });
    }

    $('.modify-deposit-btn').on('click enter', function(e) {
        $('.funding-step-2').fadeOut(function() {
            $('.funding-step-1').fadeIn();
            $('.funding-step-2').find('.authorize').addClass('d-none');
        });
    });

    function showAuthorization(form)
    {
        var pmtType = form.querySelector('[name=pmt_type]').value;
        $('.funding-step-2 [name=pmt_type]').val(pmtType);
        var $authorizePage = null;

        if(pmtType == 'card' || pmtType == 'later' || pmtType == 'funding') {

            var deposit = form.querySelector('[name=deposit]').value.replace("$", "").replace(/,/g, '');
            var programFee = document.getElementsByName('program_fee')[0].value;
            var fundLaterFee = document.getElementsByName('fund_later_fee')[0].value;
            var processingFee = document.getElementsByName('processing_fee')[0].value;
            var debit = 0;

            // Check for the domain-specifics
            if (MyLib.cardType != "latitude") {
              programFee = 0;
            }

            if(pmtType == 'card') {

                debit = parseFloat(deposit) + parseFloat(programFee);
                $authorizePage = $('.funding-step-2 .authorize-card');
    
                // Update Expedited Option
                var expedited = form.querySelector('[name=is_expedited]').checked;
                if(!expedited) {
                    $authorizePage.find('.expedited-amount-wrapper').addClass('d-none');
                } else {
                    var processingFeeAmount = '$' + numberWithCommas(Number(processingFee).toFixed(2));
                    $authorizePage.find('.expedited-amount').html(processingFeeAmount);
                    $authorizePage.find('.expedited-amount-wrapper').removeClass('d-none');
                }
            }
    
            if(pmtType == 'later') {
                debit = parseFloat(programFee) + parseFloat(fundLaterFee);
                $authorizePage = $('.funding-step-2 .authorize-later');
            }

            if(pmtType == 'funding') {
                debit = parseFloat(deposit);
                $authorizePage = $('.funding-step-2 .authorize-funding');
            }

            // Update Deposit Label
            var depositAmount = '$' + numberWithCommas(Number(deposit).toFixed(2));
            $authorizePage.find('.deposit-amount').html(depositAmount);
            // Update Debit Label
            var debitAmount = '$' + numberWithCommas(Number(debit).toFixed(2));
            $authorizePage.find('.debit-amount').html(debitAmount);
        }

        
        if(pmtType == 'expedited') {
            $authorizePage = $('.funding-step-2 .authorize-expedited');
        }

        if($authorizePage) {
            // Update DOB
            fixCCExpDateInput(form);

            // Update Cardholder name
            var cardName = form.querySelector('[name=cardname]').value;
            $authorizePage.find('.auth-cardname').html(cardName);

            // Update last 4 cc digits
            var ccNum = form.querySelector('[name=cardnumber]').value;
            var last4CCNum =  ccNum.substr( ccNum.length - 4);
            $authorizePage.find('.last-4-cc-num').html('[' + last4CCNum + ']');

            // Show Authorization Page
            $('.funding-step-1').fadeOut(function() {
                $('.funding-step-2').find('.authorize').addClass('d-none');
                $authorizePage.removeClass('d-none');
                $('.funding-step-2').fadeIn();
            });
        }

        var elementWrapper = $('div[class^="funding-"]').first();
        var elementPosition = elementWrapper.offset().top;

        $([document.documentElement, document.body]).animate({
            scrollTop: elementPosition
        }, 200, "linear");
    
        return;    
    }

    $('#authorizePaymentBtn').on('click enter', function(e) {
      e.preventDefault();

      // blockPage();

        var form = activeForm();
        var formId = form.getAttribute("id");
        var pmtType = $(".funding-step-2 [name=pmt_type]").val();

      // Send cardinal data for paybycard only
        if (pmtType == "card") {
            cardinalPayment(form);
        } else {
            submitPayment();
        }
    });

    function activeForm()
    {
        var pmtType = $('.funding-step-2 [name=pmt_type]').val();

        var form = null;
        switch(pmtType) {
            case 'card':
                form = cardFundingForm;
                break;
            case 'later':
                form = laterFundingForm;
            break;
            case 'funding':
                form = depositFundingForm;
            break;
            case 'expedited':
                form = expeditedProcessingForm;
            break;
        }

        return form;
    }

    function submitPayment() {

        blockPage();

        document.getElementById('authorizePaymentBtn').disabled = true;

        var pmtType = $('.funding-step-2 [name=pmt_type]').val();

        if(pmtType == 'card') {
            var isExpedited = $('.funding-step-2 .authorize-card [name=is_expedited]').is(':checked');
            if(isExpedited) {
                cardFundingForm.querySelector('[name="is_expedited"]').checked = true;
            }
            
            $(cardFundingForm).submit();
        }

        if(pmtType == 'later') {
            $(laterFundingForm).submit();
        }

        if(pmtType == 'expedited') {
            $(expeditedProcessingForm).submit();
        }

        if(pmtType == 'funding') {
            $(depositFundingForm).submit();
        }
    }

    /**
     * Helpers
     */
    $('#paymentOptionsWrapper .nav .nav-item .nav-link').prop('disabled', false);

    $('#paymentOptionsWrapper .nav .nav-item .nav-link').on('click enter ', function(e) {
        $('#paymentOptionsWrapper .nav .nav-item .nav-link').removeClass('active');
        $(this).addClass('active');

        $('.form-funding').addClass('d-none');

        const item = $(this).data('item');

        if(item == 'card') {
            $('#cardFundingForm').removeClass('d-none');
        } else if(item =='bank') {
            $('#bankFundingForm').removeClass('d-none');
        } else if(item == 'later') {
            $('#laterFundingForm').removeClass('d-none');
        }

        // $('#paymentOptionsWrapper [name=selected_pmt_type]').val('');
    });

    function fixCCExpDateInput(form) {
        var month = form.querySelector('[name="expdate_month"]').value;
        var year = form.querySelector('[name="expdate_year"]').value;

        var expDate = month + '/' + year;
        form.querySelector('[name="expdate"]').value = expDate;
        return;
    }
    
    function blockPage() {
        $.LoadingOverlay("show", {
            image: "",
            fontawesome: "fas fa-spinner fa-pulse"
        });
    }

    function unblockPage() {
        $.LoadingOverlay("hide", {
            image: "",
            fontawesome: "fas fa-spinner fa-pulse"
        });
    }

    function blockElement(el) {
        $(el).LoadingOverlay("show", {
            image: "",
            fontawesome: "fas fa-spinner fa-pulse"
        });
    }

    function unblockElement(el) {
        $(el).LoadingOverlay("hide", {
            image: "",
            fontawesome: "fas fa-spinner fa-pulse"
        });
    }

    unblockPage();


    /**
     * 
     * CARDINAL METHODS
     * 
     */

    var order = {};

    BASE_URL = "https://ccapi.firstprogress.com";

    // if(MyLib.appEnv == 'production') {
    //     BASE_URL = "https://firstprogressccws.vervent.com";
    // } else if(MyLib.appEnv == 'staging') {
    //     BASE_URL = "https://firstprogressccws.staging.vervent.com";
    // } else {
    //     BASE_URL = "https://ccapi.firstprogress.com";
    // }

    cardinalSetup();
    
    /**
     * Setup the cardinal instance after retrieving token from server.
     *
     * The 'data' array must contain: amount
     * Optional keys accepted by the server are: currency, description, channel, and transaction.
     *
     * @param  {array} data
     * @param  {array} order
     * @return null
     */
    function cardinalSetup() {

        // Setting configuration log for development environment.
        Cardinal.configure({
            logging: {
                level: "on"
            }
        });
        
        // Retrieving token to setup Cardinal.
        $.ajax({
            url: BASE_URL + '/api/cardinal/payload/encode',
            type: 'POST',
            data: { tracking_key : MyLib.trackingKey },
        }).done(function(response) {

            if (parseInt(response.response_code) == 1) {
                Cardinal.setup("init", {
                    jwt: response.token
                });
                // NOTICE:
                // Do not call Cardinal.start() here.
                // Listen to Cardinal.on('payments.setupComplete' [...] instead.
            } else {
                throw new Error('Message from server: ' + response.response_text);
            }

        }).fail(function(error) {
            console.log(error);
        });
    }

    /**
     * Create an order object and start the Cardinal request.
     * 
     * @return null
     */
    function cardinalPayment($form) {
        var amount = $('[name=deposit]').val().replace('$', '');
        var accountNumber = $($form).find('[name=cardnumber]').val();
        var expDate = $($form).find('[name=expdate]').val();
        var expMonth = $($form).find('[name=expdate_month]').val();
        var expYear = $($form).find('[name=expdate_year]').val();
        // var expMonth = expDate.split('/')[0];
        // var expYear = expDate.split('/')[1];

        var data = {
         amount: parseFloat(amount),
         accountNumber: accountNumber.replace(/\s/g, ""),
         expMonth: expMonth.replace(/\s/g, ""),
         expYear: expYear.replace(/\s/g, ""),
         order: '',
         currency: '',
         description: '',
         channel: '',
         transaction: '',
        };

        // Result can be retrieved by listening to 'Cardinal.on("payments.validated", ...'.
        cardinalStart(data, $form);
    }

    /**
     * Start payment validation. The result should be retrieved 
     * by listening to 'payments.validated' event.
     *
     * The 'data' array must contain: amount, accountNumber, expMonth, and expYear.
     * Optional keys are order, currency, description, channel, and transaction.
     * 
     * @param  {array} data 
     * @return null
     */
    function cardinalStart(data, $form) {
        validateCardinalStart(data);

        var number = Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000;

        // Order must have at least account, expiration month, expiration year, and amount.
        var order = {
            OrderDetails: {
                OrderNumber: 'ORDER-' + number,
                CurrencyCode: 840,
                Amount: data.amount
            },
            Consumer: {
                Account: {
                    AccountNumber: data.accountNumber,
                    ExpirationMonth: data.expMonth,
                    ExpirationYear: data.expYear
                }
            }
        }

        // Start order validation -- result should be retrieved by listening in:
        // Cardinal.on("payments.validated", function (data, jwt) {...
        Cardinal.start("cca", order);

        // this.displayLoadingInResponseDiv();
        //this.displayMessageInActionDiv('Waiting...');
        // blockPage();
        // displayCardinalMessage();
    }

    /**
     * Validate data before starting a Cardinal request. 
     * Throws an exception if a required field is not present.
     * 
     * @param  {array} data 
     * @return null
     */
    function validateCardinalStart(data) {
        // Required fields.
        var required = ['amount', 'accountNumber', 'expMonth', 'expYear'];

        // Check if all required fields are present.
        for (var i = 0; i < required.length; i++) {
            if (!(required[i] in data)) {
                throw new Error('Cardinal start requires ' + required[i] + ' value')
            }
        }

        return;
    }

    /**
     * Handle cardinal response.
     * 
     * @param  {array}  data Data from cardinal
     * @param  {String} jwt  JWT token
     * @return null
     */
    Cardinal.on("payments.validated", function (data, jwt) {
        console.log('validated')
        const that = this;
        var timeoutCodes = [10001, 10002, 10003];

        // In case of timeout, Cardinal doesn't send us a JWT. Thus, 
        // we handle this case before decoding the JWT in our server.
        if (timeoutCodes.indexOf(data.ErrorNumber) !== -1) {
            this.displayDataInResponseDiv(data);
            this.displayMessageInActionDiv('Cardinal connection timed out -- proceed with auth message');
        } else {
            
            // Validate JWT in server before handling response.
            $.ajax({
                url: BASE_URL + '/api/cardinal/payload/decode',
                type: 'POST',
                data: {token : jwt, tracking_key : MyLib.trackingKey},
                beforeSend: function() {
                    blockPage();
                },
                complete: function() {
                    // unblockPage();
                },
            }).done(function(response) {
    
                handlePaymentValidated(response);
    
            }).fail(function(error) {
                console.log(error);
            });

        }
    });

    function handlePaymentValidated(response) {
        
        // Use decoded data from server, not from Cardinal,
        // since more information is available this way.
        var cardinalData = false;
        if(parseInt(response.response_code) == 1) {
            cardinalData = typeof response.data != 'undefined' ? JSON.stringify(response.data) : false;
        }

        var form = activeForm();

        $('<input>', {
            type: 'hidden',
            name: 'cardinal_data',
            value: cardinalData
        }).appendTo(form);

        logCardinalResponse(cardinalData);

        submitPayment();

        return;
    }

    /**
     * Starts BIN Detection and Cardinal validation.
     */
    Cardinal.on('payments.setupComplete', function (setupCompleteData) {
        // console.log(setupCompleteData);
        // cardinalBinProcessAndStart(order);
    });

    function logCardinalResponse(cardinal) {
        $.ajax({
            url: '/cardinal/log',
            type: 'POST',
            data: { cardinal_data : cardinal, tracking_key :  MyLib.trackingKey },
        }).done(function(response) {
            // console.log(response);
        }).fail(function(error) {
            console.log(error);
        });
    }

    function numberWithCommas(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

}); 